import { render, staticRenderFns } from "./ConfigTree.vue?vue&type=template&id=24637b2a&scoped=true&"
import script from "./ConfigTree.vue?vue&type=script&lang=js&"
export * from "./ConfigTree.vue?vue&type=script&lang=js&"
import style0 from "./ConfigTree.vue?vue&type=style&index=0&id=24637b2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24637b2a",
  null
  
)

export default component.exports